import { useCallback } from "react";

import { PARNASSUS_HOST } from "@/challenges/utils/constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useChallengesGet = () => {
  const createEventRecordRequest = useCallback((params) => {
    const month = params.month;
    const year = params.year;
    const url = `${PARNASSUS_HOST}/challenges/?month=${month}&year=${year}`;
    const requestConfig = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    };
    return new Request(url, requestConfig);
  }, []);
  return useRestMutation(createEventRecordRequest);
};

export default useChallengesGet;
